<div class="custom-snackbar flex justify-between items-center">
  <div class="snackbar-content">
    <div class="icon-container">
      <div class="icon-circle icon-circle-1 {{data.type}}">
        <div class="icon-circle icon-circle-2 {{data.type}}">
          <div class="icon-circle icon-circle-3 {{data.type}}">
            <mat-icon [class]="data.type">{{ getIcon() }}</mat-icon>
          </div>
        </div>
      </div>

    </div>
    <div class="message font-geist font-medium">{{ data.message || 'Notification' }}</div>
  </div>
  <button class="close-button" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
